import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { chakraTheme } from 'cj-common-react';
import { ChakraProvider } from '@chakra-ui/react';
import App from './App';
import { config } from './config';
import './App.css';

ReactDOM.render(
  <Router>
    <Auth0Provider
      domain={config.DOMAIN}
      clientId={config.CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: config.AUDIENCE,
      }}
    >
      <ChakraProvider theme={chakraTheme}>
        <App />
      </ChakraProvider>
    </Auth0Provider>
  </Router>,
  document.getElementById('root'),
);
